// types
import type { DefaultConfigProps } from "./types/config";

// ==============================|| THEME CONSTANT ||============================== //

export const twitterColor = "#1DA1F2";
export const facebookColor = "#3b5998";
export const linkedInColor = "#0e76a8";

export const APP_DEFAULT_PATH = "/";
export const HORIZONTAL_MAX_ITEM = 7;
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

export enum SimpleLayoutType {
  SIMPLE = "simple",
  LANDING = "landing",
}

export enum ThemeMode {
  LIGHT = "light",
  DARK = "dark",
}

export enum MenuOrientation {
  VERTICAL = "vertical",
  HORIZONTAL = "horizontal",
}

export enum ThemeDirection {
  LTR = "ltr",
  RTL = "rtl",
}

export enum NavActionType {
  FUNCTION = "function",
  LINK = "link",
}

export enum DropzoneType {
  DEFAULT = "default",
  STANDARD = "standard",
}

// ==============================|| THEME CONFIG ||============================== //

const config: DefaultConfigProps = {
  fontFamily: `'Public Sans', sans-serif`,
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  container: true,
  mode: ThemeMode.LIGHT,
  presetColor: "theme1",
  themeDirection: ThemeDirection.LTR,
};

export default config;
